"use strict";
import { List } from "immutable";
export default (...parameters) => {
  const tuple = List.of(...parameters);
  tuple.isTuple = true;
  return tuple;
};
